"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IF = void 0;
exports.IF = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 3, max: 3 },
    },
    evaluate: (inputs) => {
        const [condition, trueResult, falseResult] = inputs;
        // Array handling for condition input
        if (Array.isArray(condition)) {
            const result = condition.map((element) => Boolean(element) === true ? trueResult : falseResult);
            return { error: null, result };
        }
        if (Boolean(condition) === true) {
            return { error: null, result: trueResult };
        }
        return { error: null, result: falseResult };
    },
};
//# sourceMappingURL=if.js.map